import serialize from './serialize.js';
import axios from 'axios';

export default class HeroHandler {
    constructor() {
        const ERROR_USER_EXISTS = 'ERR_USER_EXISTS';
        const ERR_ALREADY_SELF_ENROLLED = 'ERR_ALREADY_SELF_ENROLLED';

        const enrollmentForm = document.querySelector('[data-w-overlay-form]');
        if (!enrollmentForm) return;

        const enrollmentFormInput = enrollmentForm.querySelector('input');
        const enrollmentFormButton = enrollmentForm.querySelector('button');
        const enrollmentFormFeedback = enrollmentForm.querySelector(
            '[data-w-overlay-message]'
        );
        const overlayBox = document.querySelector('[data-w-overlay-box]');

        const url = enrollmentForm.getAttribute('action'); // /api/courses/code/self-enroll

        /**
         * @param {string} email
         * @return {boolean}
         */
        function validEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
        /**
         * @param {string} email
         */
        function sendForm(email) {
            // console.log(email);
            enrollmentFormInput.disabled = true;
            enrollmentFormButton.disabled = true;
            // try {
            axios({
                url,
                method: `POST`,
                data: {
                    email: email,
                },
                headers: {
                    'Content-Type': `application/json`,
                },
            })
                .then((response) => {
                    // enrollmentFormInput.value = ``;
                    overlayBox.innerHTML = `<div class="w-overlay__success"><span>Vielen Dank!</span><span>Eine Einladung wurde an die angegebene E-Mail Adresse gesendet</span></div>`;
                })
                .catch((response) => {
                    enrollmentFormInput.disabled = false;
                    enrollmentFormButton.disabled = false;
                    handleApiError(response);
                });
            // } catch (e) {
            //     // console.error(e);

            //     handleApiError(e);
            // }
        }
        /**
         * @param {SubmitEvent} event
         */
        function handleSubmit(event) {
            event.preventDefault();
            const email = enrollmentFormInput.value;
            if (validEmail(email)) {
                sendForm(email);
            } else {
                enrollmentFormFeedback.innerHTML = `Die eingebene E-Mail Adresse ist ungültig`;
            }
        }
        /**
         * @param {Error} error
         */
        function handleApiError(error) {
            if (error.error === ERROR_USER_EXISTS) {
                enrollmentFormFeedback.innerHTML = `User existiert bereits.`;
            } else if (error.error === ERR_ALREADY_SELF_ENROLLED) {
                enrollmentFormFeedback.innerHTML = `Eine E-Mail wurde bereits verschickt.`;
            } else {
                enrollmentFormFeedback.innerHTML = `Daten konnten nicht gesendet werden.`;
            }
        }
        function focusError() {
            const email = enrollmentFormInput.value;
            if (validEmail(email)) {
                enrollmentFormFeedback.innerHTML = ``;
                enrollmentFormInput.setCustomValidity('');
            }
        }
        function blurError() {
            const email = enrollmentFormInput.value;
            if (validEmail(email)) {
                enrollmentFormFeedback.innerHTML = ``;
                enrollmentFormInput.setCustomValidity('');
            } else {
                enrollmentFormFeedback.innerHTML = `Die eingebene E-Mail Adresse ist ungültig`;
                enrollmentFormInput.setCustomValidity(
                    'Ungültige E-Mail Adresse'
                );
            }
        }
        enrollmentForm.addEventListener('submit', handleSubmit);
        enrollmentFormInput.addEventListener('focus', focusError);
        enrollmentFormInput.addEventListener('blur', blurError);
    }
}
